module.exports = "<headerMenu></headerMenu>\r\n\r\n<br/><br/><br/>\r\n\r\n<app-messagelist></app-messagelist>\r\n<span defaultOverlayTarget></span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component.html
// module id = ./src/app/dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component.html
// module chunks = main